module.exports = __webpack_public_path__ + "img/header_mobile_new.7828b92a.png";